import './styles/main.scss'
import MainPage from './main-page.js';

function App() {
  return (
    <MainPage/>
  );
}

export default App;
